import React, { useMemo, useCallback } from "react";
import t from "common/i18n";
import ScrollableBar from "../../ScrollableBar";
import TopMenuItem from "../../TopMenuItem";
import useMenuRouteChange from "../../../hooks/useMenuRouteChange";


const ScrollableMenuItem = ({ titles, ...props }) =>
	<TopMenuItem {...props} title={t(titles[props.id])} />;

const ScrollableMenuItems = ({ navigateToPath, items, titles, activeItemId }) => {
	const routes = useMenuRouteChange();
	const onItemClick = useCallback((e, id, path) => {
		if (id !== activeItemId) {
			navigateToPath(routes[id] ?? path );
		}
	}, [activeItemId, navigateToPath, routes]);

	const getIsShownAsActive = useCallback((id) => id === activeItemId, [activeItemId]);

	const itemProps = useMemo(() => ({
		getIsShownAsActive,
		titles
	}), [getIsShownAsActive, titles]);

	const focusedItemIndex = useMemo(() => {
		return items.findIndex((item) => item.id === activeItemId);
	}, [items, activeItemId]);

	return <ScrollableBar
		items={items}
		itemProps={itemProps}
		ItemComponent={ScrollableMenuItem}
		onItemClick={onItemClick}
		focusedItemIndex={focusedItemIndex}
	/>;
};

export default ScrollableMenuItems;
